<template>
    <div class="xshzlist" :style="{
        minHeight: `calc(100vh - ${topHeight}px )`,
    }">
        <div class="Contain" :style="{
            minHeight: `calc(100vh - ${topHeight}px )`,
        }">
            <div class='xyhcontent' :style="{
                minHeight: `calc(100vh - ${topHeight}px )`,
            }">

                <div class="zlBox ">
                    <div class="leftBox">
                        <img :src="commenUrl + prevItem?.zgtp" alt="">
                        <div class='boxWrite'>{{ prevItem?.zgmc }}</div>
                        <div class='zzBox'>
                            <img class="seebtn" @click="goToPrev" src="../../assets/images/xszgDetail/see.png" alt="">
                        </div>
                    </div>
                    <div class="leftjt" @click='goToPrev'>
                        <img src="../../assets/images/xszgDetail/leftjt.png" alt="">
                    </div>
                    <div class="centerBox">
                        <img :src="commenUrl + currentItem?.zgtp" alt="">
                        <div class='boxWrite'>{{ currentItem?.zgmc }}</div>

                    </div>
                    <div class="rightjt" @click='goToNext'>
                        <img src="../../assets/images/xszgDetail/rightjt.png" alt="">
                    </div>
                    <div class="rightBox">
                        <img :src="commenUrl + nextItem?.zgtp" alt="">
                        <div class='boxWrite'>{{ nextItem?.zgmc }}</div>
                        <div class='zzBox'>
                            <img class="seebtn" @click="goToNext" src="../../assets/images/xszgDetail/see.png" alt="">
                            <!-- <div class="seebtn" @click='goToNext'>点击查看</div> -->
                        </div>
                    </div>
                </div>

                <div class="centerImg">
                    <img class='centerbottom' src="../../assets/images/xszgDetail/centerbottom.png" alt="">
                    <img @click='handleclickreturn' class='returnhome'
                        src="../../assets/images/xszgDetail/returnhomes.png" alt="">
                </div>
                <div class='listcon'>
                    <div class="title">展览企业</div>
                    <img class='titleLine' src="../../assets/images/xszgDetail/titleLine.png" alt="">

                    <el-carousel :interval="5000" :arrow="always" height='251px' indicator-position="none">
                        <el-carousel-item v-for="(item, index) in zlqyList" :key="index">
                            <div class='listbox'>
                                <div class="listItem" v-for='(i, k) in item' :key='k'
                                    @click='handleclickqyDetail(i._id)'>
                                    <div class="itemImg" v-if="i.qytp">
                                        <img :src="commenUrl + i.qytp.split(',')[0]" alt="">
                                    </div>
                                    <div class="itemImgs" v-else>
                                        <img src="../../assets/images/xszgDetail/qytp.png" alt="">
                                    </div>
                                    <div class='itemCon'>
                                        <div class="itemTitle">{{ i.qymc }}</div>
                                        <div class="itemwrite">{{ i.qyjj }}</div>
                                    </div>
                                </div>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>

            </div>

            <div class="containBottom2">
                <div class='containBottomCon'>
                    <div>云览名企 VR探场 优企联动</div>
                    <div>即刻入馆 抢抓商机 18910514060</div>
                </div>
            </div>

        </div>

    </div>



    <div class="diaBox">
        <el-dialog v-model="dialogVisible" title="企业详情" width="1200" append-to-body top='50px'>
            <div class="diaCon">
                <div class="diaConLsft">
                    <div class="carBox">
                        <iframe v-if='djobj.flag == 1' style='width:100%;height:100%' :src="djobj.url"
                            frameborder="0"></iframe>
                        <img  style='width:100%;height:100%' v-if="djobj.url && djobj.flag!=1" :src="commenUrl + djobj.url" alt="">
                    </div>
                    <div class='chooseList'>
                        <el-carousel :interval="5000" :arrow="hover" height='100px' indicator-position="none">
                            <el-carousel-item v-for="(item, index) in urls" :key="index">
                                <div class="xhList">
                                    <div class='xhItem' v-for="(i, v) in item" :key='v' @click='handleclickitem(i)'>
                                        <div class='xhItemBoder' v-if='i.flag == 1'>
                                            <img src="../../assets/images/xszgDetail/vrbj.png" alt="">
                                        </div>

                                        <img v-else :src="commenUrl + i.url" alt="">
                                    </div>
                                </div>
                            </el-carousel-item>
                        </el-carousel>

                    </div>

                </div>
                <div class="diaConright">
                    <div class="gowzshop" v-if='result.qywz' @click='handleclickgowz(result.qywz)'>前往公司网站></div>
                    <div class="goscshop" v-if='result.qysc' @click='handleclickgowz(result.qysc)'>去商城 ></div>
                    <div class='rightTitle'>{{ result.qymc }}</div>
                    <div class="rightBq">{{ result.qybq }}</div>
                    <div class="rightConWrite">{{ result.qyjs }}</div>
                    <div class="scsp" v-if = 'spList.length>0'>企业商品</div>
                    <div class="spList">
                        <div class="spItem" v-for="(item, index) in spList" :key='index' @click = 'handleclickspDetail(item.splj)'>
                            <img v-if='item.sptp' :src="commenUrl + item.sptp" alt="">
                            <img v-else src="../../assets/images/newsDefault.png" alt="">

                            <div>
                                <p class='title'>{{ item.spmc }}</p>
                                <p class="sysl">{{ item.spkc }}</p>
                                <p class="price" v-if = 'item.spjg'>¥ {{ item.spjg }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>

    </div>

</template>
<script setup>
import { ref, getCurrentInstance, computed, watch, onMounted } from "vue";

import { useRoute, useRouter } from "vue-router";

const router = useRouter();
const route = useRoute();
const { proxy } = getCurrentInstance();
onMounted(() => {
    getListInfo()
})
const dialogVisible = ref(false)
const props = defineProps({
    topHeight: {
        type: Number,
        default: 0
    }
})
let zgId = ref(route.query.id);
const pageInfo = ref({
    pageSize: 100,
    pageNo: 1
})
const getListInfo = () => {
    proxy.$request({
        method: "post",
        url: "QPSTZX_SXYZG_SXYZGLIST",
        data: {

        },
    }).then((res) => {
        if (res.data.code == "000") {
            list.value = res.data.result
        }
    });
}
const zlqyList = ref([])

const getZgDetail = () => {
    proxy.$request({
        method: "post",
        url: "QPSTZX_SXYZG_ZGQYLIST",
        data: {
            id: zgId.value,
            pageInfo: pageInfo.value
        },
    }).then((res) => {
        if (res.data.code == "000") {
            // zlqyList.value = res.data.result.list;

            zlqyList.value = groupArray(res.data.result.list, 8)

        }
    });
}
getZgDetail()

const handleclickspDetail = (url) =>{
    if(url){
        window.open(url)
    }
   
}



const handleclickreturn = () => {
    router.go(-1)
}

const topHeight = ref(props.topHeight);
const windowHeight = ref(window.innerHeight);

// 更新窗口高度
const updateWindowHeight = () => {
    windowHeight.value = window.innerHeight;
};

onMounted(() => {
    window.addEventListener('resize', updateWindowHeight);
});

// 计算 100vh - topHeight 的值
const vhMinusTopHeight = computed(() => {
    return windowHeight.value - topHeight.value;
});

// 计算 1080 - topHeight 的值
const fixedMinusTopHeight = computed(() => {
    return 1080 - topHeight.value;
});

// 判断使用哪个值
const useFixedValue = computed(() => {
    return vhMinusTopHeight.value < fixedMinusTopHeight.value;
});

// 优化后的最小高度计算
const computedMinHeight = computed(() => {
    if (vhMinusTopHeight.value < fixedMinusTopHeight.value) {
        return `${fixedMinusTopHeight.value}px`;
    } else {
        return `calc(100vh - ${topHeight.value}px)`;
    }
});


// const vhMinusTopHeight = computed(() => {
//     if(`calc(1080 - ${props.topHeight})` <= `calc(100vh - ${props.topHeight})` ){
//         return `calc(100vh - ${props.topHeight})px`
//     }else{
//         return `calc(1080 - ${props.topHeight})px`
//     }
//     // console.log(props.topHeight,900)
//     // return windowHeight.value - topHeight.value;
// });


const list = ref([]);
const currentId = ref(route.query.id);

const currentIndex = computed(() => {
    return list.value.findIndex(item => item._id == currentId.value);
});

// 计算上一条数据的索引（考虑边界情况）
const prevIndex = computed(() => {
    if (currentIndex.value === 0) {
        return list.value.length - 1; // 如果是第一条，上一条是最后一条
    }
    return currentIndex.value - 1;
});

// 计算下一条数据的索引（考虑边界情况）
const nextIndex = computed(() => {
    if (currentIndex.value === list.value.length - 1) {
        return 0; // 如果是最后一条，下一条是第一条
    }
    return currentIndex.value + 1;
});

// 当前数据项
const currentItem = computed(() => {
    return list.value[currentIndex.value];
});

// 上一条数据项
const prevItem = computed(() => {
    return list.value[prevIndex.value];
});

// 下一条数据项
const nextItem = computed(() => {
    return list.value[nextIndex.value];
});

// 切换到上一条
const goToPrev = () => {
    currentId.value = prevItem.value._id;
    zgId.value = currentId.value
    getZgDetail()

};

// 切换到下一条
const goToNext = () => {
    currentId.value = nextItem.value._id;
    zgId.value = currentId.value
    getZgDetail()
};








const groupArray = (arr, size) => {//轮播图数组转换
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
        result.push(arr.slice(i, i + size));
    }
    return result;
}

const djobj = ref({})
const result = ref({})
const spList = ref([])
const urls = ref([])
const handleclickqyDetail = (id) => {
    djobj.value= {}
    urls.value = []
    spList.value = []
    dialogVisible.value = true
    proxy.$request({
        method: "post",
        url: "QPSTZX_SXYZG_ZGQYSPLIST",
        data: {
            id: id,
        },
    }).then((res) => {
        if (res.data.code == "000") {
            result.value = res.data.result
            if (res.data.result.urls.length > 0) {
                djobj.value = res.data.result.urls[0]
                urls.value = groupArray(res.data.result.urls, 5)
            }
            spList.value = res.data.result.spList.slice(0, 4)

            spList.value.map( (item) =>{
                
                if(item.splj){
                    proxy.$request({
                        method: "post",
                        url: "SHOPHOME_FINDESPRODUCTINFO",
                        data: {
                            id: item.splj.split('=')[1],
                        },
                    }).then((res) => {
                        if (res.data.code == "000") {
                            item.sptp = res.data.result.productImgs.split(',')[0]
                            item.spmc = res.data.result.productName
                            var unit = ''
                            JSON.parse(res.data.result.keyAttributes).map((item) =>{
                                if(item.label == '计量单位'){
                                    unit = item.value
                                }
                            })

                            if(res.data.result.inventoryModel == '1' && res.data.result.productSpecs[0].dayOutput){
                                item.spkc = res.data.result.productSpecs[0].dayOutput  +  unit
                            }
                            if(res.data.result.inventoryModel == '0' && res.data.result.productSpecs[0].stock){
                                item.spkc = res.data.result.productSpecs[0].stock + unit
                            }
                            if(res.data.result.productSpecs[0].salesPriceType == '1'){
                                item.spjg = '面议'
                            }else{
                                item.spjg = res.data.result.productSpecs[0].price.toFixed (2) + '元/'+ unit
                            }
                            
                        }
                    });

                }
            })


            // SHOPHOME_FINDSHOPINFO
        }
    });

}
const handleclickitem = (obj) => {
    djobj.value = obj
}


const handleclickgowz = (wzPath) => {
    window.open(wzPath)
}


</script>
<style lang="less" scoped>

.el-dialog {
    height: 825px !important;
    margin-top: 30px !important;
}

.el-dialog__header {
    border-bottom: 1px solid #DDE6F1;
    height: 36px;

    .el-dialog__title {
        color: #313A4B;
        font-weight: 900;
    }
}

.diaCon {
    width: 100%;
    height: 760px;
    // background:pink;
    display: flex;
    padding-top: 20px;
    justify-content: space-between;

    .diaConLsft {
        width: 600px;
        height: 720px;

        .carBox {
            height: 600px;
            background: #E1EAF9;
        }

        .chooseList {
            width: 100%;
            height: 100px;
            // background:pink;
            margin-top: 20px;

            .xhList {
                display: flex;

                // justify-content: space-between;
                .xhItem {
                    width: 100px;
                    height: 100px;
                    background: #E1EAF9;
                    border-radius: 4px;
                    margin-right: 20px;

                    // border: 1px solid #1663FF;
                    .xhItemBoder {
                        width: 96px;
                        height: 98px;
                        background: #E1EAF9;
                        border-radius: 4px;
                        margin-right: 20px;
                        display: flex;
                        justify-content: space-around;
                        align-items: center;

                        img {
                            width: 56px;
                            height: 43px;
                            display: block;
                            border-radius: 4px;
                        }
                    }

                    img {
                        width: 98px;
                        height: 98px;
                        display: block;
                        border-radius: 4px;
                    }
                }
            }
        }

    }

    .diaConright {
        width: 535px;
        height: 735px;
        position: relative;

        .gowzshop {
            width: 143px;
            height: 56px;
            background: #DFEAFF;
            border-radius: 4px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #1663FF;
            line-height: 22px;
            text-align: left;
            font-style: normal;
            display: flex;
            justify-content: space-around;
            align-items: center;
            position: absolute;
            right: 0;
            cursor: pointer;
        }

        .goscshop {
            width: 90px;
            height: 28px;
            background: #DFEAFF;
            border-radius: 17px 17px 0px 0px;
            padding: 0 16px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 14px;
            color: #1663FF;
            line-height: 20px;
            text-align: left;
            font-style: normal;
            display: flex;
            align-items: center;
            position: absolute;
            bottom: -15px;
            left: 200px;
        }

        .rightTitle {
            height: 33px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 24px;
            color: #313A4B;
            line-height: 33px;
            text-align: left;
            font-style: normal;
        }

        .rightBq {
            height: 22px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #1663FF;
            line-height: 22px;
            text-align: left;
            font-style: normal;
            margin-top: 5px;
        }

        .rightConWrite {
            margin-top: 24px;
            width: 535px;
            height: 360px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #748199;
            line-height: 24px;
            text-align: left;
            font-style: normal;
            // display: -webkit-box;
            // -webkit-box-orient: vertical;
            // -webkit-line-clamp: 15; 
            overflow: auto;

        }

        .scsp {
            margin: 25px 0 13px;
            width: 130px;
            height: 28px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 20px;
            color: #313A4B;
            line-height: 28px;
            text-align: left;
            font-style: normal;
        }

        .spList {
            width: 100%;
            height: 200px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .spItem {
                width: 256px;
                height: 82px;
                display: flex;
                cursor: pointer;

                img {
                    width: 82px;
                    height: 82px;
                    background: #E1EAF9;
                    border-radius: 4px;
                    margin-right: 12px;
                }

                .title {
                    width: 162px;
                    height: 22px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 16px;
                    color: #313A4B;
                    line-height: 22px;
                    text-align: left;
                    font-style: normal;
                    overflow: hidden;
                    /* 隐藏溢出的内容 */
                    text-overflow: ellipsis;
                    /* 显示省略号 */
                    white-space: nowrap;
                    /* 防止文本换行 */
                }

                .sysl {
                    width: 162px;
                    height: 20px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #313A4B;
                    line-height: 20px;
                    text-align: left;
                    font-style: normal;
                    margin: 3px 0 15px 0
                }

                .price {
                    width: 100%;
                    height: 20px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 20px;
                    text-align: left;
                    font-style: normal;
                }
            }
        }
    }
}

@media (max-width: 500px) {
.xshzlist{
    .Contain{
     padding-top:150px;
     box-sizing: border-box;  
    
    }
   
}
}



.xshzlist {
    
    .Contain {
        box-sizing: content-box;
        min-width: 1240px;
        // min-height: 1080px;
        width: 100%;
        background: url('../../assets/images/xszgDetail/bjImg.png') no-repeat;
        background-size: 100% 100%;
        position: relative;

        .xyhcontent {
            width: 1240px;
            margin: 0 auto;
            position: relative;

            .zlBox {
                position: absolute;
                width: 100%;
                height: 290px;
                // background:pink;
                z-index: 600;
                display: flex;
                padding: 0px 39px 0;
                justify-content: space-between;
                align-items: center;
                box-sizing: border-box;

                .leftBox {
                    width: 260px;
                    height: 260px;
                    position: relative;
                    overflow: hidden;
                    background-size: 100% 100%;
                    position: relative;
                    overflow: hidden;
                    border-radius: 20px;

                    .boxWrite {
                        width: 100%;
                        height: 42px;
                        position: absolute;
                        bottom: -10px;
                        font-size: 24px;
                        font-weight: 900;
                        color: #fff;
                        left: 70px;
                    }

                    .zzBox {
                        display: flex;
                        width: 260px;
                        height: 260px;
                        // background:pink;
                        position: absolute;
                        left: 0;
                        top: 0;
                        justify-content: space-around;
                        align-items: center;

                        .seebtn {
                            width: 65px;
                            height: 65px;
                            display: none;

                            img {
                                width: 65px;
                                height: 65px;
                                display: block;
                            }
                        }
                    }

                    .zzBox:hover .seebtn {
                        display: block;
                    }


                }


                .leftjt {
                    width: 42px;
                    height: 42px;
                    cursor: pointer;

                    img {
                        width: 42px;
                        height: 42px;
                    }
                }

                .centerBox {
                    width: 480px;
                    height: 260px;
                    position: relative;
                    overflow: hidden;
                    border-radius: 20px;
                    img{
                        width:100%;
                        height:100%;
                    }

                    .boxWrite {
                        width: 100%;
                        height: 42px;
                        position: absolute;
                        bottom: -10px;
                        font-size: 24px;
                        font-weight: 900;
                        color: #fff;
                        left: 170px;
                        overflow: hidden;
                    }


                }

                .rightjt {
                    width: 42px;
                    height: 42px;
                    cursor: pointer;

                    img {
                        width: 42px;
                        height: 42px;
                    }
                }

                .rightBox {
                    width: 260px;
                    height: 260px;
                    position: relative;
                    overflow: hidden;
                    border-radius: 20px;

                    .boxWrite {
                        width: 100%;
                        height: 42px;
                        position: absolute;
                        bottom: -10px;
                        font-size: 24px;
                        font-weight: 900;
                        color: #fff;
                        left: 70px;
                    }

                    .zzBox {
                        display: flex;
                        width: 260px;
                        height: 260px;
                        // background:pink;
                        position: absolute;
                        left: 0;
                        top: 0;
                        justify-content: space-around;
                        align-items: center;

                        .seebtn {
                            width: 65px;
                            height: 65px;
                            display: none;

                            img {
                                width: 65px;
                                height: 65px;
                                display: block;
                            }
                        }
                    }

                    .zzBox:hover .seebtn {
                        display: block;
                    }
                }
            }

            .centerImg {
                position: absolute;
                width: 100%;
                height: 320px;
                background: url('../../assets/images/xszgDetail/centerImg.png') no-repeat;
                background-size: 100% 100%;
                margin-top: 200px;
                display: flex;
                justify-content: space-around;

                .returnhome {
                    position: absolute;
                    left: 200px;
                    top: 100px;
                    width: 66px;
                    height: 66px;
                    cursor: pointer;
                }


                .centerbottom {
                    width: 440px;
                    height: 80px;
                    margin-top: 80px;
                }
            }

            .listcon {
                width: 100%;
                height: 34vh;
                background: linear-gradient(rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
                position: relative;
                top: 380px;
                z-index: 800;
                // background:pink;

                .buttonBox {
                    position: absolute;
                    width: 97px;
                    height: 36px;
                    display: flex;
                    justify-content: space-between;
                    bottom: -18px;
                    left: 47%;

                    img {
                        width: 36px;
                        height: 36px;
                        cursor: pointer;
                    }
                }

                .title {
                    width: 96px;
                    height: 28px;
                    font-weight: 900;
                    font-size: 24px;
                    color: #313A4B;
                    line-height: 28px;
                    text-align: left;
                    font-style: normal;
                    margin: 0 auto;
                }

                .titleLine {
                    display: block;
                    width: 96px;
                    height: 4px;
                    margin: 7px auto 20px;
                }

                .listbox .listItem:nth-child(4) {
                    margin-right: 0 !important;
                }

                .listbox .listItem:nth-child(8) {
                    margin-right: 0 !important;
                }

                .listbox {
                    width: 100%;
                    height: 27vh;
                    // background:blue;
                    display: flex;
                    flex-wrap: wrap;
                    padding: 0 20px;

                    .listItem {
                        width: 264px;
                        height: 11vh;
                        display: flex;
                        // background:yellow;
                        margin-bottom: 40px;
                        margin-right: 30px;
                        cursor: pointer;

                        .itemImg {
                            width: 11vh;
                            height: 11vh;
                            background: #E1EAF9;
                            border-radius: 4px;

                            img {
                                width: 11vh;
                                height: 11vh;
                            }
                        }

                        .itemImgs {
                            width: 11vh;
                            height: 11vh;
                            background: #E1EAF9;
                            border-radius: 4px;
                            display: flex;
                            justify-content: space-around;
                            align-items: center;

                            img {
                                width: 56px;
                                height: 56px;
                            }
                        }

                        .itemCon {
                            flex: 1;
                            height: 100%;
                            margin-left: 15px;
                            padding: 4px 0;

                            .itemTitle {
                                width: 151px;
                                height: 20px;
                                font-family: PingFangSC, PingFang SC;
                                font-weight: 600;
                                font-size: 16px;
                                color: #313A4B;
                                line-height: 20px;
                                text-align: left;
                                font-style: normal;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;



                            }


                            .itemwrite {
                                width: 100%;
                                height: 72px;
                                font-family: PingFangSC, PingFang SC;
                                font-weight: 400;
                                font-size: 12px;
                                color: #748199;
                                line-height: 24px;
                                text-align: left;
                                font-style: normal;
                                margin-top: 4px;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 3;
                                /* 限制行数为3 */
                                overflow: hidden;

                                // display: -webkit-box;
                                // display: -moz-box;
                                // display: -ms-flexbox;
                                // display: -webkit-flex;
                                // display: flex;
                                // overflow: hidden;
                                // position: relative;
                                // max-height: 80px;
                                // /* 3行的高度 */
                                // text-align: justify;
                                // /* 防止最后一行内容不均匀 */
                                // margin-right: -1em;
                                // /* 防止最后一行内容溢出容器 */
                                // padding-right: 20px;
                                // /* 防止最后一行内容溢出容器 */


                            }

                            // .itemwrite::after {
                            //     content: '...';
                            //     position: absolute;
                            //     bottom: 0;
                            //     right: 0;
                            //     padding-left: 20px;
                            //     /* 根据需要调整 */
                            // }
                        }
                    }

                }
            }
        }

        .containBottom2 {
            width: 100%;
            height: 300px;
            background: url('../../assets/images/hzbottom.png') no-repeat;
            background-size: 100% 100%;
            position: absolute;
            bottom: -2px;
            left: 0;
            z-index: 1;
            display: flex;
            align-items: end;
            padding-bottom: 20px;
            box-sizing: border-box;
            .containBottomCon {
                width: 1200px;
                height: 45px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                font-size: 26px;
                color: #FFFFFF;
                font-weight: 900;
                align-items: center;
                padding: 0 30px;
            }
        }


    }

}

@media (min-width: 1680px) {
    .xshzlist {

        .Contain {
            box-sizing: content-box;
            min-width: 1600px;
            width: 100%;
            background: url('../../assets/images/xszgDetail/bjImg.png') no-repeat;
            background-size: 100% 100%;
            position: relative;

            .xyhcontent {
                width: 1600px;
                margin: 0 auto;
                position: relative;

                .zlBox {
                    position: absolute;
                    width: 100%;
                    height: 300px;
                    // height: 36vh;
                    // background:pink;
                    z-index: 600;
                    display: flex;
                    padding: 0px 69px 0;
                    justify-content: space-between;
                    align-items: center;
                    box-sizing: border-box;
                    .leftBox {
                        width: 336px;
                        height: 260px;
                        // height: 29vh;
                        position: relative;
                        overflow: hidden;
                        border-radius: 20px;

                        .boxWrite {
                            width: 100%;
                            height: 42px;
                            position: absolute;
                            bottom: 0px;
                            font-size: 30px;
                            font-weight: 900;
                            color: #fff;
                            left: 100px;
                        }

                        .zzBox {
                            display: flex;
                            width: 336px;
                            height: 300px;
                            height: 28vh;
                            // background:blue;
                            position: absolute;
                            left: 0;
                            top: 0;
                            justify-content: space-around;
                            align-items: center;

                            .seebtn {
                                width: 65px;
                                height: 65px;
                                display: none;

                                img {
                                    width: 65px;
                                    height: 65px;
                                    display: block;
                                }
                            }
                        }

                        .zzBox:hover .seebtn {
                            display: block;
                        }
                    }

                    .leftjt {
                        width: 52px;
                        height: 52px;
                        cursor: pointer;

                        img {
                            width: 52px;
                            height: 52px;
                        }
                    }

                    .centerBox {
                        width: 658px;
                         height: 260px;
                        // height: 29vh;
                        position: relative;
                        overflow: hidden;
                        border-radius: 20px;

                        .boxWrite {
                            width: 100%;
                            height: 42px;
                            position: absolute;
                            bottom: 0px;
                            font-size: 30px;
                            font-weight: 900;
                            color: #fff;
                            left: 240px;
                        }
                    }

                    .rightjt {
                        width: 52px;
                        height: 52px;
                        cursor: pointer;

                        img {
                            width: 52px;
                            height: 52px;
                        }
                    }

                    .rightBox {
                        width: 336px;
                        height: 260px;
                        // height: 29vh;
                        position: relative;
                        overflow: hidden;
                        border-radius: 20px;

                        .boxWrite {
                            width: 100%;
                            height: 42px;
                            position: absolute;
                            bottom: 0px;
                            font-size: 30px;
                            font-weight: 900;
                            color: #fff;
                            left: 100px;
                        }

                        .zzBox {
                            display: flex;
                            width: 336px;
                            height: 300px;
                            height: 28vh;
                            // background:pink;
                            position: absolute;
                            left: 0;
                            top: 0;
                            justify-content: space-around;
                            align-items: center;

                            .seebtn {
                                width: 65px;
                                height: 65px;
                                display: none;

                                img {
                                    width: 65px;
                                    height: 65px;
                                    display: block;
                                }
                            }
                        }

                        .zzBox:hover .seebtn {
                            display: block;
                        }
                    }
                }

                .centerImg {
                    position: absolute;
                    width: 100%;
                    height: 553px;
                    height: 50vh;
                    background: url('../../assets/images/xszgDetail/centerImg.png') no-repeat;
                    background-size: 100% 100%;
                    margin-top: 140px;
                    display: flex;
                    justify-content: space-around;

                    .returnhome {
                        position: absolute;
                        left: 280px;
                        top: 200px;
                        top: 18vh;
                        width: 66px;
                        height: 66px;
                        cursor: pointer;

                    }

                    .centerbottom {
                        width: 606px;
                        height: 117px;
                        height: 11vh;
                        margin-top: 160px;
                        margin-top: 14vh;
                    }
                }

                .listcon {
                    width: 100%;
                    height: 330px;
                    background: linear-gradient(rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
                    position: relative;
                    // top: 470px;
                    top: 45vh;
                    z-index: 800;
                    // background:red;
                    height: 33vh;

                    .title {
                        width: 96px;
                        height: 33px;
                        font-weight: 900;
                        font-size: 24px;
                        color: #313A4B;
                        line-height: 33px;
                        text-align: left;
                        font-style: normal;
                        margin: 0 auto;
                    }

                    .titleLine {
                        display: block;
                        width: 96px;
                        height: 4px;
                        margin: 7px auto 20px;
                    }

                    .listbox .listItem:nth-child(4) {
                        margin-right: 0 !important;
                    }

                    .listbox .listItem:nth-child(8) {
                        margin-right: 0 !important;
                    }

                    .listbox {
                        width: 100%;
                        height: 24vh;
                        // background:pink;
                        display: flex;
                        flex-wrap: wrap;

                        .listItem {
                            width: 364px;
                            height: 10vh;
                            display: flex;
                            margin-bottom: 40px;
                            margin-right: 20px;
                            cursor: pointer;
                            .itemImg {
                                width: 10vh;
                                height: 10vh;
                                background: #E1EAF9;
                                border-radius: 4px;

                                img {
                                    width: 10vh;
                                    height: 10vh;
                                }
                            }

                            .itemImgs {
                                width: 10vh;
                                height: 10vh;
                                background: #E1EAF9;
                                border-radius: 4px;
                                display: flex;
                                justify-content: space-around;
                                align-items: center;

                                img {
                                    width: 56px;
                                    height: 56px;
                                }
                            }

                            .itemCon {
                                flex: 1;
                                height: 100%;
                                margin-left: 15px;
                                padding: 4px 0;

                                .itemTitle {
                                    width: 241px;
                                    height: 24px;
                                    font-family: PingFangSC, PingFang SC;
                                    font-weight: 600;
                                    font-size: 20px;
                                    color: #313A4B;
                                    line-height: 24px;
                                    text-align: left;
                                    font-style: normal;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                }

                                .itemwrite {
                                    width: 100%;
                                    height: 62px;
                                    font-family: PingFangSC, PingFang SC;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #748199;
                                    line-height: 22px;
                                    text-align: left;
                                    font-style: normal;
                                    margin-top: 7px;
                                }
                            }
                        }

                    }
                }




            }

            .containBottom2 {
                width: 100%;
                height: 300px;
                background: url('../../assets/images/hzbottom.png') no-repeat;
                background-size: 100% 100%;
                position: absolute;
                bottom: -2px;
                left: 0;
                z-index: 1;
                display: flex;
                align-items: end;
                padding-bottom: 20px;
                box-sizing: border-box;

                .containBottomCon {
                    width: 1600px;
                    height: 45px;
                    margin: 0 auto;
                    // margin-top: 20vh;
                    display: flex;
                    justify-content: space-between;
                    font-size: 38px;
                    color: #FFFFFF;
                    font-weight: 900;
                    align-items: center;
                    padding: 0 30px;
                }
            }

        }

    }

}
</style>